import { render } from "./campaignSelector.vue?vue&type=template&id=444729b8&scoped=true"
import script from "./campaignSelector.vue?vue&type=script&lang=js"
export * from "./campaignSelector.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./campaignSelector.vue?vue&type=style&index=1&id=444729b8&scoped=true&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444729b8"]])

export default __exports__